import React, { useEffect, useState, Fragment, useRef, useMemo, useCallback } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import MuiMenu from "@material-ui/core/Menu";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { ListItemSecondaryAction, MenuItem, StylesProvider, Tooltip } from "@material-ui/core";
import axios from "axios";
import { getKey } from "../../helpers/url.helper";
import { observer } from "mobx-react-lite";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { history } from "../../../helpers/history";
import { runInAction } from "mobx";
import { Space } from "../Space/Space";

function Menu({ cssId, settings, environment, current, configureValidation, isSmartphone, posY, setRenderSticky, renderSticky, width: moduleWidth, orders, contentLayout, ...rest }) {
  const [layouts, setLayouts] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const logoRef = useRef();
  const { fixedOnScroll, menuGroup = "", showLogo = false, logoSource = "", menuLayout = "L1:M*", mobileMenuPos = "LEFT", showLinkTooltip = false, logoLink } = settings;

  const menuLayoutArray = useMemo(() => menuLayout.split(":").filter((x) => x != ""), [menuLayout]);

  console.log(menuItems);

  useEffect(() => {
    if (!menuItems || menuItems.length === 0) {
      fetchMenuItems();
    }
  }, []);

  useEffect(() => {
    const layout = document.querySelector(".body");
    if (layout && fixedOnScroll) layout.addEventListener("scroll", isInViewport);
    return () => {
      if (layout && fixedOnScroll) layout.removeEventListener("scroll", isInViewport);
    };
  });

  const isInViewport = useCallback(
    (event) => {
      const scrollYPos = event.target.scrollTop;
      if (scrollYPos > posY) {
        if (!renderSticky) setRenderSticky(true);
      } else {
        if (renderSticky) setRenderSticky(false);
      }
    },
    [posY, renderSticky]
  );

  const fetchLayouts = useCallback(
    async (mItems) => {
      try {
        const response = await axios.get(`./api/cms/getall?eventId=${environment.eventId}`);
        setLayouts(response.data);
        if (mItems[0]?.layoutCode && current.hasContentView) {
          const layout = response.data.find((l) => l.layoutCode == mItems[0].layoutCode);
          if (layout) {
            return runInAction(() => {
              current.scopedLayout = layout;
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    [current.hasContentView, environment.eventId]
  );

  const fetchMenuItems = useCallback(async () => {
    try {
      const response = await axios.get(`./api/menu/${environment.eventId}`);
      const newMenuItems = Array.from(response.data);
      if (newMenuItems && Array.isArray(newMenuItems)) {
        debugger;
        const mI = newMenuItems
          ?.filter((x) => x.languageCode === environment.lang && (x.menuGroupName?.toLowerCase() ?? "") === menuGroup.toLowerCase())
          ?.map((nm) => {
            nm.url = replaceUrlTags(nm.url);
            return nm;
          });
        //fetch layout based on id
        setMenuItems(mI);

        if (newMenuItems.filter((nm) => nm.layoutCode != null).length > 0) {
          fetchLayouts(newMenuItems);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, [environment.eventId, fetchLayouts, replaceUrlTags, setMenuItems, environment, menuGroup]);

  const replaceUrlTags = (url) => {
    // const { orders } = props;

    let path = url.toString();
    let badgeNo = "";
    let lang = "";

    let hasOrder = orders && orders.length > 0 && orders[0].orderId !== undefined;
    if (window.location && window.location.search) {
      const paramProps = new URLSearchParams(window.location.search);
      if (paramProps.get(getKey("badgeno", paramProps))) badgeNo = paramProps.get(getKey("badgeno", paramProps));
      else if (paramProps.get(getKey("clientkey", paramProps))) badgeNo = paramProps.get(getKey("clientkey", paramProps));

      if (paramProps.get(getKey("lang", paramProps))) lang = paramProps.get(getKey("lang", paramProps));
    }
    if (/\[BadgeNo\]/gi.test(path)) {
      if (hasOrder && badgeNo) {
        path = path.replace(/\[BadgeNo\]/gi, badgeNo);
      } else {
        path = path.replace(/&*badgeno=\[BadgeNo\]/gi, "");
        path = path.replace(/&*clientkey=\[BadgeNo\]/gi, "");
      }
    }
    if (/\[ClientKey\]/gi.test(path)) {
      if (hasOrder && badgeNo) {
        path = path.replace(/\[ClientKey\]/gi, badgeNo);
      } else {
        path = path.replace(/&*badgeno=\[ClientKey\]/gi, "");
        path = path.replace(/&*clientkey=\[ClientKey\]/gi, "");
      }
    }

    if (/lang=.{3}/gi.test(path) && lang) {
      path = path.replace(/lang=.{3}/gi, "lang=" + lang);
    }
    return path;
  };

  const navigate = (url, target) => {
    if (current.hasContentView) {
      const menuItem = menuItems.find((mi) => mi.url == url);

      if (menuItem) {
        const layout = layouts.find((l) => l.layoutCode == menuItem.layoutCode);
        if (layout) {
          configureValidation();
          return runInAction(() => {
            current.scopedLayout = layout;
          });
        }
      }
    }
    if (/lang=[a-z]{3}/i.test(url)) {
      var langString = /[\?\&]{1}lang=[a-z]{3}/i.exec(url);
      url.replace(langString, `lang=${environment.lang}`);
    } else if (url.includes("?")) {
      url += `&lang=${environment.lang}`;
    } else {
      url += `?lang=${environment.lang}`;
    }
    if (target == "_self" && !url.includes("http")) {
      history.push(url, { scrollToTop: true });
    } else {
      window.open(url, target);
    }
  };

  if (isSmartphone) {
    return (
      <header className="cms-menu mobile-menu">
        <MobileMenu mobileMenuPos={mobileMenuPos} menuItems={menuItems} contentLayout={contentLayout} scopedLayout={current.scopedLayout} cssId={cssId} showLogo={showLogo} logoSrc={logoSource} navigate={navigate} />
      </header>
    );
  }

  return menuLayoutArray.map((ml, i) => {
    let cols = ml.replace(/\D+/, "");
    if (ml.includes("*")) {
      let fixedCols = 0;
      menuLayoutArray.map((x) => {
        if (x.startsWith("L") && (!showLogo || !logoSource)) return;
        var numString = x.replace(/\D+/, "");
        if (numString) {
          fixedCols += parseInt(numString);
        }
      });
      cols = moduleWidth - fixedCols;
    }
    if (ml.startsWith("S")) {
      return (
        <div key={i} style={{ width: `calc((100vw) * (${cols} / 12))` }}>
          <Space settings={{ divider: false }} />
        </div>
      );
    } else if (ml.startsWith("L") && showLogo && logoSource) {
      const imageStyle = {
        height: logoRef.current?.naturalHeight > logoRef.current?.naturalWidth ? "100%" : undefined,
        width: logoRef.current?.naturalHeight < logoRef.current?.naturalWidth ? "100%" : undefined,
        aspectRatio: `${logoRef.current?.naturalWidth} / ${logoRef.current?.naturalHeight}`,
      };
      const wrapStyle = {
        aspectRatio: `${logoRef.current?.naturalWidth} / ${logoRef.current?.naturalHeight}`,
        width: `calc((100vw) * (${cols} / 12))`,
      };
      return (
        <div key={i} className="menu-logo-wrap" style={wrapStyle}>
          {logoLink ? (
            <a href={logoLink}>
              <img ref={logoRef} className="menu-logo" style={imageStyle} src={logoSource} />
            </a>
          ) : (
            <img ref={logoRef} className="menu-logo" style={imageStyle} src={logoSource} />
          )}
        </div>
      );
    } else if (ml.startsWith("M")) {
      return (
        <header key={i} style={{ width: `calc((100vw) * (${cols} / 12))` }}>
          <DesktopMenu {...{ menuItems: menuItems, navigate, scopedLayout: current.scopedLayout, contentLayout, showLinkTooltip }} />
        </header>
      );
    }
  });
}

export default observer(Menu);

const DesktopMenu = ({ menuItems = [], navigate, contentLayout, showLinkTooltip }) => {
  const [anchorEl, setAnchorEl] = React.useState({});

  const handleClick = (event, menuId) => {
    setAnchorEl({ ...anchorEl, [menuId]: event.currentTarget });
  };

  const handleClose = (menuId) => {
    setAnchorEl({ ...anchorEl, [menuId]: null });
  };

  if (!menuItems?.length) return <p>None</p>;

  return (
    <div className="menu-items">
      {menuItems
        ?.filter((m) => !m.parentMenuId)
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map((m) => {
          const { url, label, target, menuId } = m;
          return (
            <Fragment key={`desktop_${url}_${menuId}`}>
              <Tooltip title={url} disableFocusListener disableTouchListener disableHoverListener={!showLinkTooltip}>
                {menuItems.find((mi) => mi.parentMenuId == menuId) ? (
                  <>
                    <div
                      className="cms-menu-item"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={(e) => handleClick(e, menuId)}
                    >
                      {label}
                      <ExpandMoreIcon style={{ marginLeft: 10 }} />
                    </div>
                    <MuiMenu
                      MenuListProps={{ className: "cms-menu-list" }}
                      className="menu-items"
                      anchorEl={anchorEl[menuId]}
                      getContentAnchorEl={null}
                      anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
                      transformOrigin={{ horizontal: "center", vertical: "top" }}
                      keepMounted
                      open={Boolean(anchorEl[menuId])}
                      onClose={() => handleClose(menuId)}
                    >
                      {menuItems
                        .filter((mi) => mi.parentMenuId == menuId)
                        .sort((a, b) => a.sortOrder - b.sortOrder)
                        .map((mi) => (
                          <StylesProvider key={mi} injectFirst>
                            <MenuItem className={`cms-menu-item ${contentLayout.layoutCode == mi.layoutCode ? "active" : ""}`} key={mi.menuId} onClick={() => navigate(mi.url, mi.target)}>
                              {mi.label}
                            </MenuItem>
                          </StylesProvider>
                        ))}
                    </MuiMenu>
                  </>
                ) : (
                  <div onClick={() => navigate(url, target)} className={`cms-menu-item ${contentLayout.layoutCode == m.layoutCode ? "active" : ""}`}>
                    {label}
                  </div>
                )}
              </Tooltip>
            </Fragment>
          );
        })}
    </div>
  );
};

const MobileMenu = ({ menuItems = [], match, navigate, cssId, contentLayout, scopedLayout, logoLink, mobileMenuPos, showLogo, logoSrc }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openMenuOptionId, setOpenMenuOptionId] = useState(null);

  const toggleMenuOption = (id) => setOpenMenuOptionId(openMenuOptionId != id ? id : null);

  const toggleDrawer = (event) => {
    setDrawerOpen(!drawerOpen);
  };

  const logoRef = useRef();
  const imageStyle = {
    height: logoRef.current?.naturalHeight > logoRef.current?.naturalWidth ? "100%" : undefined,
    width: logoRef.current?.naturalHeight < logoRef.current?.naturalWidth ? "100%" : undefined,
    aspectRatio: `${logoRef.current?.naturalWidth} / ${logoRef.current?.naturalHeight}`,
  };
  const wrapStyle = {
    aspectRatio: `${logoRef.current?.naturalWidth} / ${logoRef.current?.naturalHeight}`,
  };

  return (
    <React.Fragment>
      {mobileMenuPos === "RIGHT" ? (
        <div className="menu-logo-wrap" style={wrapStyle}>
          {showLogo && logoSrc ? (
            <div className="menu-logo-wrap" style={wrapStyle}>
              {logoLink ? (
                <a href={logoLink}>
                  <img ref={logoRef} className="menu-logo" style={imageStyle} src={logoSrc} />
                </a>
              ) : (
                <img ref={logoRef} className="menu-logo" style={imageStyle} src={logoSrc} />
              )}
            </div>
          ) : null}
        </div>
      ) : null}
      <IconButton aria-controls="simple-menu" className="hamburger" onClick={() => toggleDrawer()} aria-haspopup="true">
        <MenuIcon />
      </IconButton>
      {mobileMenuPos === "LEFT" ? (
        <div className="menu-logo-wrap" style={wrapStyle}>
          {showLogo && logoSrc ? <img ref={logoRef} className="menu-logo" style={imageStyle} src={logoSrc} /> : null}
        </div>
      ) : null}
      <Drawer id={cssId} PaperProps={{ className: "cms-mobile-menu" }} anchor={mobileMenuPos?.toLowerCase()} open={drawerOpen} onClose={() => toggleDrawer()}>
        <div role="presentation" onClick={() => toggleDrawer()} onKeyDown={() => toggleDrawer()}>
          <List className="menu-items">
            {menuItems
              ?.filter((m) => !m.parentMenuId)
              ?.map((item, index) => {
                const { url, target } = item;
                return menuItems.find((mi) => mi.parentMenuId == item.menuId) ? (
                  <React.Fragment key={index}>
                    <ListItem
                      key={index}
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleMenuOption(item.menuId);
                      }}
                    >
                      <ListItemText primary={item.label} />
                      <ListItemSecondaryAction>
                        <IconButton>
                          <ExpandMoreIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    {openMenuOptionId == item.menuId ? (
                      <div style={{ marginLeft: 20 }}>
                        {menuItems
                          .filter((mi) => mi.parentMenuId == item.menuId)
                          .map((mi) => {
                            return (
                              <ListItem
                                onClick={() => navigate(mi.url, mi.target)}
                                className={`cms-menu-item ${scopedLayout ? scopedLayout.layoutCode == mi.layoutCode : contentLayout.layoutCode == mi.layoutCode ? "active" : ""}`}
                                button
                                key={`mobile_${mi.url}}_${mi.menuId}`}
                              >
                                <ListItemText primary={mi.label} />
                              </ListItem>
                            );
                          })}
                      </div>
                    ) : null}
                  </React.Fragment>
                ) : (
                  <ListItem onClick={() => navigate(url, target)} className={`cms-menu-item ${contentLayout.contentLayoutId == item.layoutId ? "active" : ""}`} button key={`mobile_${item.url}}_${item.menuId}`}>
                    <ListItemText primary={item.label} />
                  </ListItem>
                );
              })}
          </List>
        </div>
      </Drawer>
    </React.Fragment>
  );
}; //#BTHAEEO.content-wrapper .cms-menu .cms-menu-item
